import { useEffect, useState } from "react";

export default function Counter({ target, duration = 2000 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target);
    if (start === end) return;

    const increment = Math.ceil(end / (duration / 30));

    const timer = setInterval(() => {
      start += increment;
      if (start > end) start = end;
      setCount(start);

      if (start === end) clearInterval(timer);
    }, 30);

    return () => clearInterval(timer);
  }, [target, duration]);

  return <span>{count}</span>;
}
